import stCompareLoanProducts from './compareLoanProducts.component';
import stFundingWorksheet from './fundingWorksheet.component';
import homeLoanController from './homeLoan.controller';
import HomeLoan from './homeLoan.model';
import homeLoanService from './homeLoan.service';
import HomeLoanApplication from './homeLoanApplication.model';
import HomeLoanApplicationBackChannelHistory from './homeLoanApplicationBackChannelHistory.model';
import HomeLoanApplicationLodgeHistory from './homeLoanApplicationLodgeHistory.model';
import stHomeLoanCommissions from './homeLoanCommissions.component';
import CompareProduct from './homeLoanCompareProduct.model';
import CompareProductSplit from './homeLoanCompareProductSplit.model';
import stHomeLoanCompliance from './homeLoanCompliance.component';
import HomeLoanCompliance from './homeLoanCompliance.model';
import ContactForValuation from './homeLoanContactForValuation.model';
import homeLoanDataFactory from './homeLoanData.factory';
import FeeAndCharge from './homeLoanFeeAndCharge.model';
import FeeAndChargeType from './homeLoanFeeAndChargeType.model';
import FundingWorksheet from './homeLoanFundingWorksheet.model';
import FundingWorksheetFundsAvailableSplit from './homeLoanFundingWorksheetFundsAvailableSplit.model';
import FundingWorksheetFundsRequiredSplit from './homeLoanFundingWorksheetFundsRequiredSplit.model';
import FundingWorksheetOtherDebt from './homeLoanFundingWorksheetOtherDebt.model';
import NeedsAnalysis from './homeLoanNeedsAnalysis.model';
import OtherMortgage from './homeLoanOtherMortgage.model';
import homeLoanPreferredProductSummary from './homeLoanPreferredProductSumary.component';
import RefinanceAnalysis from './homeLoanRefinanceAnalysis.model';
import ReviewProduct from './homeLoanReviewProduct.model';
import ReviewProductSplit from './homeLoanReviewProductSplit.model';
import HomeLoanSearchProduct from './homeLoanSearchProduct.model';
import SecurityDetails from './homeLoanSecurityDetails.model';
import SecuritySplit from './homeLoanSecuritySplit.model';
import homeLoanSwitchController from './homeLoanSwitch.controller';
import SwitchCompareProduct from './homeLoanSwitchCompareProduct.model';
import SwitchProduct from './homeLoanSwitchProduct.model';
import SwitchReviewProduct from './homeLoanSwitchReviewProduct.model';
import homeLoanSwitchSubmit from './homeLoanSwitchSubmit.component';
import TitleDetail from './homeLoanTitleDetail.model';
import HomeLoanVerificationApplicant from './homeLoanVerificationApplicant.model';
import stMaximumBorrowing from './maximumBorrowing.component';
import stNeedsAnalysis from './needsAnalysis.component';
import stRefinanceAnalysis from './refinanceAnalysis.component';
import stReviewLoanProducts from './reviewLoanProducts.component';
import stSearchLoanProducts from './searchLoanProducts.component';
import stSecurityDetails from './securityDetails.component';
import stSummary from './summary.component';
import stSwitchReviewProduct from './switchReviewProduct.component';

export default angular
  .module('st.HomeLoan', [
    'st.Core',
    'angular-cache',
    'st.Core.GoogleMaps',
    'ui.utils.masks',
    'vsGoogleAutocomplete'
  ])
  .component('stCompareLoanProducts', stCompareLoanProducts)
  .component('stFundingWorksheet', stFundingWorksheet)
  .controller('homeLoanController', homeLoanController)
  .factory('HomeLoan', HomeLoan)
  .service('homeLoanService', homeLoanService)
  .factory('HomeLoanApplication', HomeLoanApplication)
  .factory('HomeLoanApplicationBackChannelHistory', HomeLoanApplicationBackChannelHistory)
  .factory('HomeLoanApplicationLodgeHistory', HomeLoanApplicationLodgeHistory)
  .component('stHomeLoanCommissions', stHomeLoanCommissions)
  .factory('CompareProduct', CompareProduct)
  .factory('CompareProductSplit', CompareProductSplit)
  .component('stHomeLoanCompliance', stHomeLoanCompliance)
  .factory('HomeLoanCompliance', HomeLoanCompliance)
  .factory('ContactForValuation', ContactForValuation)
  .factory('homeLoanDataFactory', homeLoanDataFactory)
  .factory('FeeAndCharge', FeeAndCharge)
  .factory('FeeAndChargeType', FeeAndChargeType)
  .factory('FundingWorksheet', FundingWorksheet)
  .factory('FundingWorksheetFundsAvailableSplit', FundingWorksheetFundsAvailableSplit)
  .factory('FundingWorksheetFundsRequiredSplit', FundingWorksheetFundsRequiredSplit)
  .factory('FundingWorksheetOtherDebt', FundingWorksheetOtherDebt)
  .factory('NeedsAnalysis', NeedsAnalysis)
  .factory('OtherMortgage', OtherMortgage)
  .component('homeLoanPreferredProductSummary', homeLoanPreferredProductSummary)
  .factory('RefinanceAnalysis', RefinanceAnalysis)
  .factory('ReviewProduct', ReviewProduct)
  .factory('ReviewProductSplit', ReviewProductSplit)
  .factory('HomeLoanSearchProduct', HomeLoanSearchProduct)
  .factory('SecurityDetails', SecurityDetails)
  .factory('SecuritySplit', SecuritySplit)
  .controller('homeLoanSwitchController', homeLoanSwitchController)
  .factory('SwitchCompareProduct', SwitchCompareProduct)
  .factory('SwitchProduct', SwitchProduct)
  .factory('SwitchReviewProduct', SwitchReviewProduct)
  .component('homeLoanSwitchSubmit', homeLoanSwitchSubmit)
  .factory('TitleDetail', TitleDetail)
  .factory('HomeLoanVerificationApplicant', HomeLoanVerificationApplicant)
  .component('stMaximumBorrowing', stMaximumBorrowing)
  .component('stNeedsAnalysis', stNeedsAnalysis)
  .component('stRefinanceAnalysis', stRefinanceAnalysis)
  .component('stReviewLoanProducts', stReviewLoanProducts)
  .component('stSearchLoanProducts', stSearchLoanProducts)
  .component('stSecurityDetails', stSecurityDetails)
  .component('stSummary', stSummary)
  .component('stSwitchReviewProduct', stSwitchReviewProduct)
  .constant('HOME_LOAN', {
    API: {
      DOWNLOAD_CALCULATOR: '/api/v1/loan/download-calculator-data/',
      SWITCH: '/api/v1/loan/switch/',
      SEND_COMMISSION: '/api/v1/loan/send-commission/'
    },
    DETAILS: {
      APPLICANTS: [
        { id: 0, value: 'Select one', weight: 1 },
        { id: 1, value: '1', weight: 2 },
        { id: 2, value: '2', weight: 3 },
        { id: 3, value: '3', weight: 4 },
        { id: 4, value: '4', weight: 5 },
        { id: 5, value: '5', weight: 6 },
        { id: 6, value: '6', weight: 7 }
      ],
      VALUATION_CONTACT_TYPES: [
        { id: 0, value: 'Select one', weight: 1 },
        { id: 1, value: 'Real estate agency', weight: 2 },
        { id: 2, value: 'Tenant', weight: 3 },
        { id: 3, value: 'Other', weight: 4 }
      ],
      PRODUCT_FEE_TYPE_RELATIONS: [
        { idProductType: 'APPLICATION', idAssociatedFee: '' },
        { idProductType: 'UPFRONT', idAssociatedFee: '' },
        { idProductType: 'RATE_LOCK', idAssociatedFee: '' },
        { idProductType: 'MONTHLY', idAssociatedFee: '' },
        { idProductType: 'YEARLY', idAssociatedFee: '' },
        { idProductType: 'VALUATION', idAssociatedFee: 'valuation_fee' },
        { idProductType: 'SETTLEMENT', idAssociatedFee: '' },
        { idProductType: 'LEGAL', idAssociatedFee: '' },
        { idProductType: 'RISK', idAssociatedFee: '' },
        { idProductType: 'ORIGINATION', idAssociatedFee: 'lender_origination_fee' },
        { idProductType: 'DOCUMENT', idAssociatedFee: 'document_fee' },
        { idProductType: 'PPSR', idAssociatedFee: 'ppsr' },
        { idProductType: 'BOF', idAssociatedFee: '' },
        { idProductType: 'OTHER', idAssociatedFee: 'other_misc' }
      ],
      MORTGAGE_PRIORITY: [
        { id: '', value: 'Select one', weight: 1 },
        { id: 1, value: 'First', weight: 2 },
        { id: 2, value: 'Second', weight: 3 },
        { id: 3, value: 'Third', weight: 4 },
        { id: 4, value: 'Fourth', weight: 5 },
        { id: 5, value: 'Guarantee', weight: 6 },
        { id: 6, value: 'Unregistered mortgage', weight: 7 }
      ],
      REFINANCE_TYPES: [
        { id: 0, value: 'Select one', weight: 1, llField: 'NONE' },
        { id: 1, value: 'Internal', weight: 2, llField: 'INTERNAL' },
        { id: 2, value: 'External', weight: 3, llField: 'EXTERNAL' }
      ],
      PROPERTY_STATUS: [
        { id: 0, value: 'Select one', weight: 1 },
        {
          id: 1,
          value: 'Established property',
          weight: 2
        },
        {
          id: 2,
          value: 'Vacant land',
          weight: 3
        },
        {
          id: 3,
          value: 'Land and construction',
          weight: 4
        },
        {
          id: 4,
          value: 'New building',
          weight: 5
        },
        {
          id: 5,
          value: 'Construction',
          weight: 6
        }
      ],
      CONSTRUCTION_TYPES: [
        { id: 0, value: 'Select one', weight: 1 },
        { id: 1, value: 'House land package', weight: 2 },
        { id: 2, value: 'Licensed builder', weight: 3 },
        { id: 3, value: 'Minor non-structural repairs', weight: 4 },
        { id: 4, value: 'Owner builder', weight: 5 }
      ],
      CONSTRUCTION_PROPERTY_TYPES: [
        { id: 0, value: 'Select one', weight: 1 },
        { id: 1, value: 'Apt unit flat', weight: 2 },
        { id: 2, value: 'Fully detached house', weight: 3 },
        { id: 3, value: 'Townhouse', weight: 4 }
      ],
      SIMPLE_SELECT_OPTIONS: [
        { id: '', value: 'Select one', weight: 1 },
        { id: 1, value: 'Yes', weight: 2 },
        { id: 2, value: 'No', weight: 3 },
        { id: 3, value: 'N/A', weight: 4 }
      ],
      INTERVIEW_METHODS: [
        { id: '', value: 'Select one', weight: 1 },
        { id: 1, value: 'In person', weight: 2 },
        { id: 2, value: 'Video conference', weight: 3 },
        { id: 3, value: 'Phone call', weight: 4 }
      ],
      EMPLOYMENT_VERIFICATION_METHOD: [
        { id: 1, value: 'Google', weight: 2 },
        { id: 2, value: 'ABN check', weight: 3 },
        { id: 3, value: 'Employer call', weight: 4 },
        { id: 4, value: 'Transaction statements', weight: 5 }
      ],
      REPAYMENT_TYPE: [
        { id: '', value: 'Not essential', weight: 1, searchField: 'NOT_ESSENTIAL' },
        { id: 'PI', value: 'Principal & interest', weight: 2, searchField: 'PI' },
        { id: 'IO', value: 'Interest only', weight: 3, searchField: 'IO' },
        { id: 'IOA', value: 'IO in advance', weight: 4, searchField: 'IOA' }
      ],
      RATE_TYPE: [
        { id: '', value: 'Not essential', weight: 1, searchField: 'NOT_ESSENTIAL' },
        { id: 'VARIABLE', value: 'Variable', weight: 2, searchField: 'VARIABLE' },
        { id: 'FIXED', value: 'Fixed', weight: 3, searchField: 'FIXED' }
      ],
      LOAN_TYPE: [
        { id: '', value: 'Not essential', weight: 1, searchField: 'NOT_ESSENTIAL' },
        { id: 'FULL_DOC', value: 'Full doc', weight: 2, searchField: 'FULL_DOC' },
        { id: 'LOW_DOC', value: 'Low doc', weight: 3, searchField: 'LOW_DOC' }
      ],
      PROPERTY_USE: [
        { id: '', value: 'Not essential', weight: 1, searchField: 'NOT_ESSENTIAL' },
        {
          id: 'OWNER_OCCUPIED',
          value: 'Owner occupied',
          weight: 2,
          searchField: 'OWNER_OCCUPIED'
        },
        {
          id: 'RESIDENTIAL_INVESTMENT',
          value: 'Residential investment',
          weight: 2,
          searchField: 'RESIDENTIAL_INVESTMENT'
        }
      ],
      YES_NO_TYPE: [
        {
          id: 'NOT_ESSENTIAL',
          value: 'Not essential',
          weight: 1,
          searchField: 'NOT_ESSENTIAL'
        },
        { id: 'YES', value: 'Yes', weight: 2, searchField: 'YES' },
        { id: 'NO', value: 'No', weight: 2, searchField: 'NO' }
      ],
      OFFSET: [
        {
          id: 'NOT_ESSENTIAL',
          value: 'Not essential',
          weight: 1,
          searchField: 'NOT_ESSENTIAL'
        },
        { id: 'YES', value: 'Yes', weight: 2, searchField: 'YES' },
        { id: 'NO', value: 'No', weight: 2, searchField: 'NO' }
      ],
      NEEDS_ANALYSIS: {
        NATURE_OF_SERVICE_SOUGHT: [
          { id: 1, value: 'Residential', weight: 2 },
          { id: 2, value: 'Commercial', weight: 3 },
          { id: 3, value: 'Equipment', weight: 4 }
        ],
        LOCATION_OF_ASSETS_OR_FUNDS: [
          { id: 1, value: 'Local', weight: 1 },
          { id: 2, value: 'Interstate', weight: 1 },
          { id: 3, value: 'Offshore', weight: 1 }
        ],
        LEAD_SOURCING_METHOD: [
          { id: 1, value: 'Existing client', weight: 1 },
          { id: 2, value: 'Advertising', weight: 1 },
          { id: 3, value: 'Referral', weight: 1 },
          { id: 4, value: 'Unsolicited', weight: 1 }
        ]
      },
      LENDERS_BUSINESS_INCOME_RULES: {
        first: ['amb', 'anz', 'bsa', 'bom', 'fmb', 'imb', 'key', 'para', 'pnb', 'stg', 'vow'],
        second: [
          'ade',
          'afmadv',
          'afmres',
          'afmade',
          'afmpep',
          'ast',
          'axe',
          'ba',
          'bos',
          'bws',
          'bey',
          'blue',
          'cba',
          'citi',
          'her',
          'hltpep',
          'hltred',
          'hltres',
          'hltade',
          'hltmac',
          'hltadv',
          'hsf',
          'laveadv',
          'laveres',
          'laveori',
          'laveade',
          'lavepep',
          'ltb',
          'lib',
          'mezyade',
          'mezygen',
          'mezypep',
          'mezybos',
          'mezyltb',
          'mma',
          'mys',
          'qud',
          'pep',
          'resi',
          'sun',
          'vir',
          'vowres',
          'vowade',
          'vowpep',
          'vowadv'
        ],
        third: ['amp', 'aus', 'boq', 'first', 'ing', 'macq', 'me', 'nab', 'tmb', 'wbc']
      },
      ABS_LENDING_PURPOSE_CODES: [
        {
          id: 'ABS-121',
          value: 'ABS-121 - Construction of dwelling - House'
        },
        {
          id: 'ABS-123',
          value: 'ABS-123 - Construction of dwelling - Other dwelling'
        },
        {
          id: 'ABS-125',
          value: 'ABS-125 - Purchase of newly erected dwelling - House'
        },
        {
          id: 'ABS-127',
          value: 'ABS-127 - Purchase of newly erected dwelling - Other dwelling'
        },
        {
          id: 'ABS-129',
          value: 'ABS-129 - Purchase of established dwelling - House'
        },
        {
          id: 'ABS-131',
          value: 'ABS-131 - Purchase of established dwelling - Other dwelling'
        },
        {
          id: 'ABS-133',
          value:
            'ABS-133 - Refinance existing home loans - Loans held with other financial institutions'
        },
        {
          id: 'ABS-143',
          value:
            'ABS-143 - Structural and non-structural alterations and/or additions to dwellings (excluding  swimming pools, maintenance, repairs and other home improvements)'
        },
        {
          id: 'ABS-221',
          value: 'ABS-221 - Purchase of motor cars and station wagons - New'
        },
        {
          id: 'ABS-223',
          value: 'ABS-223 - Purchase of motor cars and station wagons - Used'
        },
        {
          id: 'ABS-225',
          value: 'ABS-225 - Purchase of other motor vehicles'
        },
        {
          id: 'ABS-227',
          value: 'ABS-227 - Purchase of motor cycles, scooters'
        },
        {
          id: 'ABS-229',
          value: 'ABS-229 - Purchase of boats, caravans and trailers'
        },
        {
          id: 'ABS-231',
          value: 'ABS-231 - Purchase of individual residential blocks of land'
        },
        {
          id: 'ABS-233',
          value: 'ABS-233 - Unsecured loans for alterations and/or additions to dwellings'
        },
        {
          id: 'ABS-235',
          value:
            'ABS-235 - Unsecured loans to assist in the purchase or construction of housing for owner occupation'
        },
        {
          id: 'ABS-237',
          value: 'ABS-237 - Purchase of household and personal goods'
        },
        {
          id: 'ABS-239',
          value: 'ABS-239 - Debt consolidation (excluding refinance of personal loans)'
        },
        {
          id: 'ABS-241',
          value: 'ABS-241 - Travel and holidays'
        },
        {
          id: 'ABS-243',
          value: 'ABS-243 - Refinance of personal loans (excluding investment loans)'
        },
        {
          id: 'ABS-245',
          value: 'ABS-245 - Personal investment in dwellings for rent/resale'
        },
        {
          id: 'ABS-247',
          value:
            'ABS-247 - Other personal investment (including shares and other investment assets)'
        },
        {
          id: 'ABS-248',
          value:
            'ABS-248 - Refinancing of investment loans (including  purchase of dwellings for rent/resale, purchase of shares and other investment assets)'
        },
        {
          id: 'ABS-249',
          value:
            'ABS-249 - Other purposes (including swimming pools and home improvements - other than alterations and additions, motor accessories and any other purpose)'
        },
        {
          id: 'ABS-320',
          value: 'ABS-320 - Construction of dwellings for rent/resale'
        },
        {
          id: 'ABS-321',
          value: 'ABS-321 - Construction of non-residential buildings - Shop'
        },
        {
          id: 'ABS-322',
          value: 'ABS-322 - Construction of non-residential buildings - Offices'
        },
        {
          id: 'ABS-323',
          value: 'ABS-323 - Construction of non-residential buildings - Industrial buildings'
        },
        {
          id: 'ABS-324',
          value: 'ABS-324 - Construction of non-residential buildings  - Other'
        },
        {
          id: 'ABS-326',
          value: 'ABS-326 - Construction of non-building structures'
        },
        {
          id: 'ABS-327',
          value:
            "ABS-327 - Structural and non-structural alterations and/or additions to buildings (excluding maintenance, repairs and other improvements that don't include building work)"
        },
        {
          id: 'ABS-329',
          value: 'ABS-329 - Purchase of land and buildings - Dwellings for rent/resale'
        },
        {
          id: 'ABS-330',
          value: 'ABS-330 - Purchase of land and buildings - Shops'
        },
        {
          id: 'ABS-331',
          value: 'ABS-331 - Purchase of land and buildings - Offices'
        },
        {
          id: 'ABS-332',
          value:
            'ABS-332 - Purchase of land and buildings - Industrial buildings (including factories, automotive repair facilities, etc.)'
        },
        {
          id: 'ABS-333',
          value:
            'ABS-333 - Purchase of land and buildings - Other non-residential buildings (including hotels, buildings for educational, religious, health, entertainment and recreational purposes)'
        },
        {
          id: 'ABS-335',
          value: 'ABS-335 - Purchase of land and buildings - Rural property'
        },
        {
          id: 'ABS-336',
          value:
            'ABS-336 - Purchase of land and buildings - Land for residential block development'
        },
        {
          id: 'ABS-337',
          value: 'ABS-337 - Purchase of land and buildings - Other land purchases'
        },
        {
          id: 'ABS-340',
          value:
            'ABS-340 - Wholesale Finance (including purchase of goods by wholesalers or retailers, traders stocks held under bailment or floor plan schemes or working capital)'
        },
        {
          id: 'ABS-341',
          value:
            'ABS-341 - Purchase of plant and equipment - Motor vehicles (excluding motorcycles, trailers, caravans, trains, boats and planes)'
        },
        {
          id: 'ABS-342',
          value:
            'ABS-342 - Purchase of plant and equipment - Other transport equipment (including motorcycles, trailers, caravans, trains, boats and planes)'
        },
        {
          id: 'ABS-343',
          value:
            'ABS-343 - Purchase of plant and equipment - Other plant equipment (including construction and earthmoving equipment, agricultural machinery and office equipment)'
        },
        {
          id: 'ABS-348',
          value: 'ABS-348 - Refinance of existing commercial loans'
        },
        {
          id: 'ABS-349',
          value:
            'ABS-349 - Other purpose (including factoring - whether secured by trade debts or to purchase trade debts, maintenance, repairs and other improvements to property not involving building work)'
        }
      ],
      APPLY_ONLINE_SUPPORTED_LENDERS: [
        '80aa2f23-54f0-4692-b6dd-55c9e6d2ab9d',
        'f973abd9-373b-4224-8f0f-b6f5a59237bb',
        'e990fc8c-6a4e-4e50-893f-e0aeec8aaeff',
        '0c8b40f0-cadf-4a80-94a5-83d85f15458d',
        '08ac995b-3dba-4455-a835-c80810570f42',
        '0ddf2997-a052-4335-8ac0-591ff0739e05',
        '0ffe5c22-4b7c-4682-8c24-a277b42c1e2b',
        '035d95e9-cf77-4efc-bc9f-5dc37486f6e0',
        '0d17ca77-e69b-47ae-9803-f317f8295bbf',
        '13abc846-ebcc-4f70-8752-4474949c9afc',
        '0578ce00-6921-43e6-aad7-f401f05e0284',
        '705f6e74-20c5-428e-bae5-262c3ff6ed41',
        '1696f273-34ee-4e0f-a505-2c1dc69db835',
        'bbe26d52-8b7c-4971-bd0a-ac41ba82a0f0',
        '2acc2ac1-ee0e-40ba-9548-28a85372bab0',
        '47a1baaf-acae-43e7-b2ff-caecddd7a6b1',
        '114f67a6-cfb9-4ae9-8208-7b02289f95c7',
        '1fc50637-75ab-460b-a727-da66b214b987',
        '11bc7ae0-05f7-41aa-b5f9-5e83440c9e67',
        '90819382-69b4-4527-86b8-fdd0c2c547f6',
        '82d18cee-ebbc-4c64-ab94-2913bbe1eb60',
        '2bfb75ec-7a16-4abb-bd7b-1adac2cf57f7',
        '5f693f97-e6c2-462c-9cce-ce67ab348987',
        '294af054-7d2c-4cd6-b819-1542fa307163',
        '61059459-d605-483d-98b8-2ad2dd1dcbad',
        'b711940a-d88b-40d5-85cc-2fabbba89244',
        'aa528105-0c7f-4c44-9678-fd82ce95aa3e',
        '191affdb-0656-45ea-bc47-b31a7f1c32a0',
        '2d23e347-1ccd-40e2-8ca3-44bfe7b0560d',
        '88698329-440a-4cb4-9e9d-fd59b75470c5',
        '5f675200-d535-4568-a386-884164cfa3d8',
        '9b7c4c6e-926d-4290-869d-7011a92bb163',
        'be13b223-e111-4f4e-95c3-7789011fecd2',
        'd25b136d-ed42-4863-9345-454b86cb97dd',
        '237f0f7c-fff5-4a20-a22a-e8b9879e15ef',
        '52bd957d-0258-4c59-b113-2ac57e94c8a5',
        'a34e1d15-d98e-4e33-a8a9-d22755eae2f2',
        '7fd83fdb-6e6e-42f0-bf59-4bfb2cf17afa',
        'b1002612-e485-4552-b558-f37d5bf92ee1',
        'ef06b2a6-6055-4220-a703-8a23e1d5aeea',
        'dd22c86a-c1f7-4cc9-8c44-99857ed4098f',
        'c4c05f21-eccc-41db-af8f-fc5ef64a7e6c',
        '5b2342fd-0584-4b52-8d2d-872c339d0034',
        'a873bd06-139a-412a-a54e-6ca36f43e27b',
        'a31c7897-b665-46b9-bb89-c0bdf3ea97fd',
        'd1ac3467-e3b3-4ba3-8048-2c843a6b3601',
        'f9d9ce14-e9ec-4be7-85ad-c711ecc39766',
        '893c27e6-46aa-4258-a289-1af40fca6432',
        'b1246ff5-2250-496a-9a00-a040ed146d21',
        'bd3068f9-24fb-4691-b4b7-09039fb992c6',
        'e122b32d-f674-458c-9280-8aca7fe9dfcf',
        'ab23a69f-add3-4955-819a-9578d56f5128',
        'f7ed8c80-2485-45a9-a961-353beb97bd80',
        'ed53c13d-a1e4-4834-b1dd-4ea64553bd67',
        'b7df6c02-af2e-41a9-bdf1-041eddeed138',
        'bd09c806-c5b3-45ee-8828-530815dc6e10',
        'd98fb6ff-a28c-4406-881f-a27982ebc6c1',
        'cc4a6d15-a13e-43c3-bd18-57068aeab5e4',
        '1b1efd50-666b-4f1e-9d39-d5dc73795604',
        'c06be4b7-5463-4354-8fce-d94bbb9bb936',
        '01c45fa6-d840-41d5-8fdb-12b8361de561',
        '48de9816-d762-4f16-afa3-a6f570db9561',
        '15efb23e-3e06-4f26-9cc9-56fd1f3aa44a',
        '931743d4-f845-4c19-9179-2bb8fa6e6a2d',
        'd92363fa-0c76-448f-8252-29268cf99c62',
        '7e1c0ee2-db36-412d-9f81-42b6efda1631',
        '1e09ce6d-1236-476d-a420-157b6ef9c7df',
        '88792f49-a9d5-4562-97a0-64a9cf4b83cb',
        '1c08560f-eeb2-462b-8c93-ee219ead7eba'
      ],
      APPLY_ONLINE_SUPPORTED_LENDERS_ASTUTE: [
        '88792f49-a9d5-4562-97a0-64a9cf4b83cb',
        'ef06b2a6-6055-4220-a703-8a23e1d5aeea',
        'a873bd06-139a-412a-a54e-6ca36f43e27b',
        'f973abd9-373b-4224-8f0f-b6f5a59237bb',
        'b7df6c02-af2e-41a9-bdf1-041eddeed138',
        '035d95e9-cf77-4efc-bc9f-5dc37486f6e0',
        '2bfb75ec-7a16-4abb-bd7b-1adac2cf57f7',
        'e990fc8c-6a4e-4e50-893f-e0aeec8aaeff',
        'b711940a-d88b-40d5-85cc-2fabbba89244',
        'ed53c13d-a1e4-4834-b1dd-4ea64553bd67',
        '5f693f97-e6c2-462c-9cce-ce67ab348987',
        '0c8b40f0-cadf-4a80-94a5-83d85f15458d',
        'be13b223-e111-4f4e-95c3-7789011fecd2',
        'aa528105-0c7f-4c44-9678-fd82ce95aa3e',
        '705f6e74-20c5-428e-bae5-262c3ff6ed41',
        '1696f273-34ee-4e0f-a505-2c1dc69db835',
        '0ddf2997-a052-4335-8ac0-591ff0739e05',
        'ab23a69f-add3-4955-819a-9578d56f5128',
        '0578ce00-6921-43e6-aad7-f401f05e0284',
        'bbe26d52-8b7c-4971-bd0a-ac41ba82a0f0',
        '2fa0a347-8679-4ac9-88ab-b695dbc0f413',
        '82d18cee-ebbc-4c64-ab94-2913bbe1eb60',
        'a31c7897-b665-46b9-bb89-c0bdf3ea97fd',
        'dd22c86a-c1f7-4cc9-8c44-99857ed4098f',
        '88698329-440a-4cb4-9e9d-fd59b75470c5',
        'a34e1d15-d98e-4e33-a8a9-d22755eae2f2',
        '5f675200-d535-4568-a386-884164cfa3d8',
        'c4c05f21-eccc-41db-af8f-fc5ef64a7e6c',
        '191affdb-0656-45ea-bc47-b31a7f1c32a0',
        '80aa2f23-54f0-4692-b6dd-55c9e6d2ab9d',
        '114f67a6-cfb9-4ae9-8208-7b02289f95c7',
        '52bd957d-0258-4c59-b113-2ac57e94c8a5',
        '47a1baaf-acae-43e7-b2ff-caecddd7a6b1',
        'cc4a6d15-a13e-43c3-bd18-57068aeab5e4',
        '0ffe5c22-4b7c-4682-8c24-a277b42c1e2b',
        '01c45fa6-d840-41d5-8fdb-12b8361de561',
        '48de9816-d762-4f16-afa3-a6f570db9561',
        '15efb23e-3e06-4f26-9cc9-56fd1f3aa44a',
        '931743d4-f845-4c19-9179-2bb8fa6e6a2d',
        'd92363fa-0c76-448f-8252-29268cf99c62',
        '7e1c0ee2-db36-412d-9f81-42b6efda1631',
        '1e09ce6d-1236-476d-a420-157b6ef9c7df',
        '1c08560f-eeb2-462b-8c93-ee219ead7eba',
        '36bf4dfeb46010b3589244235aa43c37'
      ],
      SIMPOLOGY_SUPPORTED_LENDERS: [
        '6052dcaa-a76f-41e1-a201-4d81fcdd52d9',
        'a31c7897-b665-46b9-bb89-c0bdf3ea97fd',
        'f9d9ce14-e9ec-4be7-85ad-c711ecc39766',
        '2acc2ac1-ee0e-40ba-9548-28a85372bab0',
        '7fd83fdb-6e6e-42f0-bf59-4bfb2cf17afa',
        '11bc7ae0-05f7-41aa-b5f9-5e83440c9e67',
        '893c27e6-46aa-4258-a289-1af40fca6432',
        'd98fb6ff-a28c-4406-881f-a27982ebc6c1',
        'b1246ff5-2250-496a-9a00-a040ed146d21',
        '294af054-7d2c-4cd6-b819-1542fa307163',
        '61059459-d605-483d-98b8-2ad2dd1dcbad',
        '81d3deb3-7f87-4b3e-8beb-d2f84023059e',
        'bedb7b42-2366-402d-95ff-0e89cfb4794d',
        '6904ce5d-a45b-475d-bae8-9671e437c897'
      ]
    }
  });
